<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h3 class="text-primary font-weight-medium">
          {{ $t("labels.share-to-collaborate") }}
        </h3>
        <small class="text-grey"
          >{{ $t("labels.add-users-to-collaborate") }}
        </small>
      </v-col>
      <v-col cols="12">
        <v-autocomplete
          variant="outlined"
          density="compact"
          persistent-hint
          :search="user"
          @update:search="user = ''"
          :no-data-text="$t('labels.no-data-available')"
          :placeholder="$t('labels.search-user')"
          item-title="username"
          :item-value="(item) => item"
          :items="users"
          append-icon=""
          prepend-icon=""
          filled
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              @click="shareUser(item.raw)"
              class="users-list"
              v-bind="props"
            ></v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-list three-line>
          <template v-if="sharedUsers.length > 0">
            <v-list-item
              v-for="(item, index) in sharedUsers"
              :key="`user` + index"
            >
              <template v-slot:prepend>
                <v-icon class="text-h4 text-primary">mdi-account-circle</v-icon>
              </template>
              <v-list-item-title
                >{{ item.firstname }} {{ item.lastname }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
              <template v-slot:append>
                <span v-if="mashup.owner === item._id" class="mr-3">{{
                  $t("labels.owner")
                }}</span>
                <span v-else class="mr-3">{{ $t("labels.editor") }}</span>
                <v-tooltip
                  location="top"
                  :disabled="mashup.owner === loggedUserId"
                >
                  <template v-slot:activator="{ props }">
                    <span v-bind="props">
                      <v-icon
                        v-if="mashup.owner !== item._id"
                        @click="unshareUser(item, index)"
                        :disabled="mashup.owner !== loggedUserId"
                        >mdi-close</v-icon
                      >
                    </span>
                  </template>
                  <span>{{ $t("strings.unshare-user-tooltip") }}</span>
                </v-tooltip>
              </template>
            </v-list-item>
          </template>
          <div v-else>{{ $t("labels.no-shared") }}</div>
        </v-list>
      </v-col>

      <v-col cols="12">
        <h3 class="text-primary font-weight-medium">
          {{ $t("labels.share-limitation") }}
        </h3>
        <small class="text-grey"> {{ $t("labels.view-only-mode") }}</small>
      </v-col>
      <v-col cols="12">
        <v-select
          variant="outlined"
          density="compact"
          :value="selectItems[0]"
          :no-data-text="$t('labels.no-data-available')"
          :items="selectItems"
        >
        </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import utils from "@/mixins/utils";
import axios from "axios";
import share from "@/mixins/SidebarShare";

export default {
  name: "ShareForm",
  mixins: [utils, share],
  props: {
    mashup: Object,
    realm: String,
    root: String,
    shareFormConfig: {},
  },
  data() {
    return {
      selectItems: [],
      sharedUsers: [],
      users: [],
      apiUrl: this.shareFormConfig.api,
      tenantId: this.realm,
      usersToShare: [],
      urlPath: "",
      user: null,
      mashupId: "",
      mashupVersion: "",
      loggedUserId: "",
    };
  },
  mounted() {
    this.loggedUserId = localStorage.getItem("loggedUserId");
    this.selectItems = [
      this.$t("labels.no-one"),
      this.$t("labels.all-members"),
      this.$t("labels.everyone"),
    ];
    this.urlPath = window.location.pathname;
    this.mashupId = this.urlPath.split("draw/").pop().split("/v")[0];
    this.mashupVersion = this.urlPath.split("v/").pop().split("/edit")[0];
    document.addEventListener("language-localstorage-changed", (event) => {
      this.setLocale(event.detail.storage);
    });
    this.getMashup();
  },
  methods: {
    shareUser(user) {
      if (user) {
        const shareUser = { user: user._id, edit: true };
        this.usersToShare.push(shareUser);
        axios
          .patch(
            this.apiUrl +
              "/" +
              this.tenantId +
              "/" +
              this.root +
              "/" +
              this.mashup._id +
              "/share",
            this.usersToShare,
            this.opts,
          )
          .then(() => {
            this.sharedUsers.push(user);
            this.users.splice(this.users.indexOf(user), 1);
            document.dispatchEvent(new CustomEvent("refresh-mashup"));
            this.user = "";
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    unshareUser(user, index) {
      if (user) {
        const userToUnshare = [user._id];
        axios
          .patch(
            this.apiUrl +
              "/" +
              this.tenantId +
              "/" +
              this.root +
              "/" +
              this.mashup._id +
              "/unshare",
            userToUnshare,
            this.opts,
          )
          .then(() => {
            this.sharedUsers.splice(index, 1);
            this.users.push(user);
            document.dispatchEvent(new CustomEvent("refresh-mashup"));
            this.user = "";
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped></style>
